// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Y74v6","placeholdersHeader":"styles_placeholdersHeader__2s8Hi","editorStyle":"styles_editorStyle__BhN0w","placeholdersBox":"styles_placeholdersBox__2R15U"};